import { render, staticRenderFns } from "./zlCertification.vue?vue&type=template&id=290f25da&scoped=true&"
import script from "./zlCertification.vue?vue&type=script&lang=js&"
export * from "./zlCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290f25da",
  null
  
)

export default component.exports